module.exports = __webpack_public_path__ + "static/media/footer-image3.e6035061.png";